import Element from './Element';

export default class SideMenuSectionMission extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'mission_section',
            layout: {
                anchors: [0, 0, 1, 0],
                pivot: [0.5, 0],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'scroll',
                    data: {
                        friction: 0.9,
                        direction: 'y',
                    },
                },
                {
                    type: 'mask',
                    data: {
                        offset: [0, 12, 0, 24],
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: 'title',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0],
                        offsets: [0, -30, 0, -30],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'Events',
                                style: {
                                    font: 'RussoOne',
                                    fill: '#fff',
                                    fontSize: '40px',
                                    stroke: '#C27E54',
                                    strokeThickness: 6,
                                },
                                align: 'center',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'key_hunt',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0.5],
                        offsets: [0, -180, 0, -180],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'mission_key_back',
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: 'title',
                            layout: {
                                anchors: [0, 0, 0, 0],
                                pivot: [0, 0],
                                offsets: [-15, -2, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'KeyHunt',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#fff',
                                            fontSize: '32px',
                                        },
                                        align: 'left',
                                    },
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: 'key_hunt_progress_text',
                            layout: {
                                anchors: [1, 0, 1, 0],
                                pivot: [1, 0],
                                offsets: [15, -2, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: '0/20',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#fff',
                                            fontSize: '30px',
                                        },
                                        align: 'right',
                                    },
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: 'key_progress',
                            layout: {
                                anchors: [0, 1, 0, 1],
                                pivot: [0, 1],
                                offsets: [-5, 5, -5, 5],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'key_bar_back',
                                    },
                                },
                            ],
                            children: [
                                {
                                    type: 'group',
                                    name: 'key_hunt_progress_bar',
                                    layout: {
                                        anchors: [0, 0.5, 0, 0.5],
                                        pivot: [0, 0.5],
                                        offsets: [-2, 0, -2, 0],
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'image',
                                            data: {
                                                cacheKey: 'key_bar_line',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: 'timer',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [-125, -80, -125, -80],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'missions_timer',
                                    },
                                },
                            ],
                            children: [
                                {
                                    type: 'group',
                                    name: 'key_hunt_timer',
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [1, 0.5],
                                        offsets: [-20, 0, 0, 0],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                textLocalizationKey:
                                                    '0:00:00:00',
                                                style: {
                                                    font: 'RussoOne',
                                                    fill: '#fff',
                                                    fontSize: '22px',
                                                },
                                                align: 'right',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'key_hunt_new_event',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0.5],
                        offsets: [0, -180, 0, -180],
                        constrains: {
                            heightMin: 170,
                            heightMax: 170,
                            widthMin: 461,
                            widthMax: 461,
                        },
                    },
                    components: [
                        {
                            type: 'nineslice',
                            data: {
                                cacheKey: 'rounded_rectangle1_9_slice',
                                offset: [15, 15, 15, 15],
                            },
                        },
                        {
                            type: 'visibility',
                            data: {
                                hidden: true,
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: 'title',
                            layout: {
                                anchors: [0.5, 0.3, 0.5, 0.3],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: 'NewEvent',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#4A2317',
                                            fontSize: '28px',
                                        },
                                        align: 'center',
                                        wordWrap: true,
                                        wordWrapWidth: 400,
                                        bounds: [400, 100],
                                    },
                                },
                            ],
                        },
                        {
                            type: 'group',
                            name: 'new_event_timer',
                            layout: {
                                anchors: [0.5, 0.7, 0.5, 0.7],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: '00:00:00',
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#fff',
                                            fontSize: '36px',
                                        },
                                        align: 'center',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'title_todos',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0.5],
                        offsets: [0, -320, 0, -320],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'ToDos',
                                style: {
                                    font: 'RussoOne',
                                    fill: '#fff',
                                    fontSize: '40px',
                                    stroke: '#C27E54',
                                    strokeThickness: 6,
                                },
                                align: 'center',
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'todos_list',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'verticalgroup',
                            data: {
                                padding: [0, 360, 0, 20],
                                spacing: 0,
                            },
                        },
                    ],
                },
            ],
            ...params,
        });
    }
}
